import { IDLE, LOADING, SUCCESS } from '../../../../enums/states';
import { createReducer } from '../../utils/reducer';
import { POS_TRANSACTION_DETAIL_FETCH, POS_TRANSACTION_DETAIL_SUCCESS } from '../../../actions/transactionDetail';

const initialState = {
  data: null,
  metadata: {
    state: IDLE,
    error: null
  }
};

const handlers = {
  [POS_TRANSACTION_DETAIL_FETCH]: (state) => {
    return {
      ...state,
      metadata: {
        state: LOADING,
      }
    };
  },

  [POS_TRANSACTION_DETAIL_SUCCESS]: (state, action) => {
    return {
      ...state,
      data: action.payload,
      metadata: {
        state: SUCCESS,
      }
    };
  },
};

export default createReducer(initialState, handlers);
